module.exports = "<div class=\"wrapper\">\n  <a class=\"focusable sub-nav-item\" href=\"#\" ng-keydown=\"vm.onKeyDown($event)\" ng-blur=\"vm.blur($event)\"></a>\n  <div class=\"left-item\" ng-bind-html=\"vm.rotationMenu[0].title\"></div>\n  <div class=\"center-item selected\" ng-bind-html=\"vm.rotationMenu[1].title\"></div>\n  <div class=\"right-item\" ng-bind-html=\"vm.rotationMenu[2].title\"></div>\n</div>\n"


/*****************
 ** WEBPACK FOOTER
 ** ./client/app/components/common/navbarSubMenu/navbarSubMenu.html
 ** module id = 147
 ** module chunks = 0
 **/